export default {
    manageAttendanceRequest: 'จัดการคำขอข้อมูลการลงเวลา',
    searchByEmployeeName: 'ค้นหาด้วยชื่อพนักงาน',
    employeeNo: 'รหัสพนักงาน',
    name: 'ชื่อ - นามสกุล',
    submitted_date: 'วันที่ส่งคำขอ',
    group_name: 'กลุ่ม',
    department_name: 'แผนก',
    request_date: 'วันที่ร้องขอ',
    status: 'สถานะ',
    search: 'ค้นหา'
}
